
<HorizontalStep
  v-if="isHorizontal"
  :active="active"
  :flow="flow"
  :index="stepIndex"
/>
<VerticalStep
  v-else
  :active="active"
  :index="stepIndex"
>
  <template #default>
    <slot name="default" />
  </template>
  <template #icon>
    <slot name="icon" />
  </template>
</VerticalStep>
